;(function () {
    "use strict"

    var STORAGE_PREFIX = "sg:views:"

    function sanitizePhone(number) {
        if (!number) return null
        return String(number).replace(/[^0-9]/g, "")
    }

    function initOne(el) {
        if (el.dataset.sgInitialized) return
        el.dataset.sgInitialized = "true"

        var sectionId = el.dataset.sectionId
        var delay = parseInt(el.dataset.sgDelaySeconds, 10) || 0
        var whatsapp = sanitizePhone(el.dataset.sgWhatsapp)
        var ctaType = el.dataset.sgCtaType || "modal"
        var ctaUrl = el.dataset.sgCtaUrl || ""
        var displayStyle = el.dataset.sgDisplayStyle || "modal"
        var modal = el.querySelector(".modal--store-greeter")

        // Settings for view limiting
        var maxViews = parseInt(el.dataset.sgMaxViews, 10)
        if (isNaN(maxViews)) maxViews = 0
        var viewPeriodDays = parseInt(el.dataset.sgViewPeriodDays, 10) || 1
        var storageKey = STORAGE_PREFIX + (sectionId || "default")

        function _getViews() {
            try {
                var raw = localStorage.getItem(storageKey)
                return raw ? JSON.parse(raw) : []
            } catch (e) {
                return []
            }
        }

        function _saveViews(arr) {
            try {
                localStorage.setItem(storageKey, JSON.stringify(arr))
            } catch (e) {}
        }

        function _prune(arr) {
            var cutoff = Date.now() - viewPeriodDays * 24 * 60 * 60 * 1000
            return arr.filter(function (t) {
                return t >= cutoff
            })
        }

        function canShow() {
            if (maxViews <= 0) return true
            return _prune(_getViews()).length < maxViews
        }

        function recordView() {
            if (maxViews <= 0) return
            try {
                var arr = _prune(_getViews())
                arr.push(Date.now())
                _saveViews(arr)
            } catch (e) {}
        }

        function show() {
            if (!canShow()) return
            el.style.display = ""
            el.removeAttribute("data-sg-initial-hidden")
            recordView()
        }

        // WhatsApp action handler
        var waButton = el.querySelector('[data-sg-action="whatsapp"]')
        if (waButton && whatsapp) {
            waButton.addEventListener("click", function (ev) {
                ev.preventDefault()
                var msg = el.dataset.sgWhatsappMsg || "Hello, I would like to schedule a video call"
                window.open("https://wa.me/" + whatsapp + "?text=" + encodeURIComponent(msg), "_blank")
            })
        } else if (waButton) {
            waButton.style.display = "none"
        }

        // CTA action handler
        var cta = el.querySelector('[data-sg-action="cta"]')
        if (cta) {
            cta.addEventListener("click", function (ev) {
                ev.preventDefault()
                if (displayStyle === "modal" || ctaType === "modal") {
                    if (modal) {
                        openModal(modal, true)
                        return
                    }
                }
                if (ctaUrl) window.open(ctaUrl, "_blank")
            })
        }

        function openModal(m, force) {
            if (!m || (!force && !canShow())) return

            if (m.parentNode !== document.body) document.body.appendChild(m)
            if (!force) recordView()

            m.classList.add("modal--open")
            m.setAttribute("aria-hidden", "false")

            // Accessibility management
            try {
                m.__sg_prevActive = document.activeElement
                Array.prototype.slice.call(document.body.children).forEach(function (node) {
                    if (node !== m) node.setAttribute("aria-hidden", "true")
                })
            } catch (e) {}

            var announcer = m.querySelector("[data-sg-modal-announcer]")
            if (announcer) announcer.textContent = el.dataset.sgModalTitle || ""

            var focusables = m.querySelectorAll(
                'a[href], input:not([disabled]), button:not([disabled]), [tabindex]:not([tabindex="-1"])'
            )
            if (focusables.length) focusables[0].focus()

            // Dynamic event listeners (Cleanup performance)
            var closeBtn = m.querySelector("[data-sg-modal-close]")
            var overlay = m.querySelector("[data-sg-modal-overlay]")

            var closeHandler = function () {
                m.classList.remove("modal--open")
                m.setAttribute("aria-hidden", "true")
                document.removeEventListener("keydown", keyHandler)
                Array.prototype.slice.call(document.body.children).forEach(function (node) {
                    if (node !== m) node.removeAttribute("aria-hidden")
                })
                if (m.__sg_prevActive) m.__sg_prevActive.focus()
            }

            var keyHandler = function (e) {
                if (e.key === "Escape") closeHandler()
                if (e.key === "Tab") {
                    var f = Array.prototype.slice.call(focusables)
                    if (e.shiftKey && document.activeElement === f[0]) {
                        e.preventDefault()
                        f[f.length - 1].focus()
                    } else if (!e.shiftKey && document.activeElement === f[f.length - 1]) {
                        e.preventDefault()
                        f[0].focus()
                    }
                }
            }

            document.addEventListener("keydown", keyHandler)
            if (closeBtn) closeBtn.onclick = closeHandler
            if (overlay) overlay.onclick = closeHandler
        }

        // Initialize display logic
        if (el.hasAttribute("data-sg-initial-hidden")) {
            setTimeout(function () {
                if (!canShow()) return
                if (displayStyle === "modal") openModal(modal)
                else show()
            }, delay * 1000)
        } else if (displayStyle === "modal") {
            el.classList.add("store-greeter--compact")
        }
    }

    function initAll() {
        document.querySelectorAll(".store-greeter").forEach(initOne)
    }

    // Shopify Theme Editor synchronization
    document.addEventListener("shopify:section:load", function (e) {
        var section = e.target.querySelector(".store-greeter")
        if (section) initOne(section)
    })

    document.addEventListener("shopify:section:unload", function (e) {
        // Cleanup modals moved to body
        var sectionId = e.detail.sectionId
        var existingModal = document.querySelector('.modal--store-greeter[id*="' + sectionId + '"]')
        if (existingModal) existingModal.remove()
    })

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", initAll)
    } else {
        initAll()
    }
})()
